export var PullRefreshStatus;

(function (PullRefreshStatus) {
  PullRefreshStatus[PullRefreshStatus["Static"] = 0] = "Static";
  PullRefreshStatus[PullRefreshStatus["Pulling"] = 1] = "Pulling";
  PullRefreshStatus[PullRefreshStatus["Loosing"] = 2] = "Loosing";
  PullRefreshStatus[PullRefreshStatus["Loading"] = 3] = "Loading";
  PullRefreshStatus[PullRefreshStatus["Finish"] = 4] = "Finish";
})(PullRefreshStatus || (PullRefreshStatus = {}));